import { Component } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

// This HtmlComponentErrorBoundary component is used to catch errors in HTML components
// It's not using the Sentry error boundary because we're not supporting custom code and we don't want to see the errors in Sentry
interface HtmlComponentErrorBoundaryState {
  hasError: boolean;
}

interface HtmlComponentErrorBoundaryProps {
  children: React.ReactNode;
}

class HtmlComponentErrorBoundary extends Component<
  HtmlComponentErrorBoundaryProps,
  HtmlComponentErrorBoundaryState
> {
  constructor(props: HtmlComponentErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <Box
          maxWidth="920px"
          margin="auto"
          justifyContent="center"
          flexDirection="column"
          py={4}
        >
          <SimpleCard
            cardProps={{ width: '100%' }}
            title={s__(
              'HtmlComponentErrorBoundary|Something went wrong in the HTML component.',
            )}
            faIconProps={{
              iconName: 'user-robot-xmarks',
            }}
          />
        </Box>
      );
    }

    return children;
  }
}

export default HtmlComponentErrorBoundary;
